  import "@nathanvda/cocoon";

  import swal from 'sweetalert2';
  window.Swal = swal;
